import { api } from './_client';

export const documentsApi = {
  // List documents
  async listDocuments(): Promise<{
    success: boolean;
    documents: Array<{
      id: string;
      organization_id: string;
      title: string;
      description: string | null;
      document_type: string;
      s3_key: string;
      original_filename: string;
      validity_start_date: string | null;
      validity_end_date: string | null;
      uploaded_by: string | null;
      file_size: number | null;
      content_type: string | null;
      created_at: string;
      updated_at: string;
    }>;
    error?: string;
  }> {
    const response = await api.get('/api/documents');
    return response.data;
  },

  // Upload document
  async uploadDocument(
    file: File,
    title: string,
    description: string | null,
    documentType: string,
    validityStartDate: string | null,
    validityEndDate: string | null
  ): Promise<{
    success: boolean;
    document: {
      id: string;
      organization_id: string;
      title: string;
      description: string | null;
      document_type: string;
      s3_key: string;
      original_filename: string;
      validity_start_date: string | null;
      validity_end_date: string | null;
      uploaded_by: string | null;
      file_size: number | null;
      content_type: string | null;
      created_at: string;
      updated_at: string;
    } | null;
    error?: string;
  }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    if (description) formData.append('description', description);
    formData.append('document_type', documentType);
    if (validityStartDate) formData.append('validity_start_date', validityStartDate);
    if (validityEndDate) formData.append('validity_end_date', validityEndDate);

    const response = await api.post('/api/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000, // 2 minutes for large file uploads
    });

    return response.data;
  },

  // Download document
  async downloadDocument(documentId: string): Promise<{
    success: boolean;
    download_url: string | null;
    expires_in: number | null;
    error?: string;
  }> {
    const response = await api.get(`/api/documents/${documentId}/download`);
    return response.data;
  },

  // Delete document
  async deleteDocument(documentId: string): Promise<{
    success: boolean;
    message?: string;
    error?: string;
  }> {
    const response = await api.delete(`/api/documents/${documentId}`);
    return response.data;
  },
};
